import SavedMessageEditForm from './saved-message-edit-form';

/**
 * Component for creating a new saved message
 */
export default SavedMessageEditForm.extend({
  /**
   * @inheritDoc
   */
  titleText: 'Add new message',

  /**
   * @inheritDoc
   */
  submitButtonText: 'Save',

  /**
   * @inheritDoc
   */
  _handleSubmit() {
    return this.onSubmitForm({
      title: this.get('newTitle'),
      body: this.get('newBody'),
    });
  },
});
